import React, { useState, useMemo, useEffect } from "react";
import styles from "./style.module.css";
import { FiSearch } from "react-icons/fi";
import { MdOutlineAccessTime, MdOutlineArrowBackIos } from "react-icons/md";
import { Pagination } from "antd";
import { TextComponent } from "../../components";
import Card from "../../components/Card/Card";
import { useDispatch, useSelector } from "react-redux";
import { AuthMiddleware } from "../../Store/Middlewares/AuthMiddleware";
import { FaUser } from "react-icons/fa6";

const ActivityLog = () => {
  const [search, setSearch] = useState("");
  const [filterAction, setFilterAction] = useState("");
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const STAFF = useSelector((state) => state.AuthReducer.getStaff) || [];
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(AuthMiddleware.getStaff());
    dispatch(AuthMiddleware.activityLogs(filterAction, currentPage)).then(
      (data) => {
        setLogs(data?.data?.data?.data || []);
        setTotal(data?.data?.data?.meta?.total || 0);
        setPerPage(data?.data?.data?.meta?.per_page || 10);
      },
    );
  }, [filterAction, currentPage, dispatch]);

  /* 🔍 Filter Activity Logs */
  const filteredLogs = useMemo(() => {
    return logs?.filter((log) =>
      log?.description?.toLowerCase().includes(search.toLowerCase()),
    );
  }, [logs, search]);

  const filterowner = STAFF?.filter((stf) => stf?.role !== "owner");

  /* 🔍 Filter Staff */
  const filteredStaffs = useMemo(() => {
    return filterowner?.filter((stf) =>
      stf?.name?.toLowerCase().includes(search.toLowerCase()),
    );
  }, [STAFF, search]);

  return (
    <Card>
      <div className={styles.activitywidget}>
        {filterAction ? (
          /* ================= ACTIVITY LOG VIEW ================= */
          <section>
            <div className={styles.topcontrols}>
              <div className={styles.activityHeader}>
                <MdOutlineArrowBackIos
                  onClick={() => {
                    setFilterAction("");
                    setSearch("");
                  }}
                  style={{ cursor: "pointer" }}
                />
                <TextComponent
                  text="Activity"
                  className={styles.headerHeading}
                />
              </div>

              <div className={styles.searchBox}>
                <FiSearch size={18} />
                <input
                  className={styles.searchbox}
                  type="text"
                  placeholder="Search activity..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>

            <div className={styles.activitylist}>
              {filteredLogs?.length > 0 ? (
                filteredLogs.map((log) => (
                  <div className={styles.activitycard} key={log.id}>
                    <div className={styles.activityicon}>
                      <MdOutlineAccessTime size={20} />
                    </div>

                    <div className={styles.activitytext}>
                      <p className={styles.action}>{log.description}</p>
                      <p className={styles.staff}>
                        {log.date} {log.time}
                      </p>
                    </div>
                  </div>
                ))
              ) : (
                <p className={styles.nodata}>No Activity Found</p>
              )}
            </div>

            {total > perPage && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: 16,
                }}
              >
                <Pagination
                  current={currentPage}
                  total={total}
                  pageSize={perPage}
                  onChange={(page) => setCurrentPage(page)}
                  showSizeChanger={false}
                />
              </div>
            )}
          </section>
        ) : (
          /* ================= STAFF VIEW ================= */
          <section>
            <div className={styles.topcontrols}>
              <TextComponent
                text="Staff Activity"
                className={styles.headerHeading}
              />

              <div className={styles.topcontrols}>
                <div className={styles.searchBox}>
                  <FiSearch size={18} />
                  <input
                    className={styles.searchbox}
                    type="text"
                    placeholder="Search staff..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
              </div>
            </div>

            {filteredStaffs?.length > 0 ? (
              filteredStaffs.map((stf) => (
                <div
                  className={styles.staffCard}
                  key={stf.id}
                  onClick={() => {
                    setFilterAction(stf?.id);
                    setSearch("");
                  }}
                >
                  <div className={styles.activityicon}>
                    <FaUser size={20} />
                  </div>

                  <div className={styles.activitytext}>
                    <p className={styles.action}>{stf.name}</p>
                    <p className={styles.staff}>{stf.email}</p>
                  </div>
                </div>
              ))
            ) : (
              <p className={styles.nodata}>No Staff Found</p>
            )}
          </section>
        )}
      </div>
    </Card>
  );
};

export default ActivityLog;
